import { apiRequest } from './httpClient';

// Plan extra meetings: N discounted meetings for a paid subscriber, one
// payment - see backend/routers/plan_addons.py. Not the Meeting Pass.
// Same apiRequest as every other service.

// What `quantity` extra meetings would cost THIS user and until when, or
// why they cannot be bought: { eligible, reason, message, quantity,
// currency, unit_price, total_amount, expires_at }. The server decides;
// the page only renders it.
export function getQuote(quantity) {
  return apiRequest(`/api/plan-addons/quote?quantity=${encodeURIComponent(quantity)}`);
}

// Opens a one-time order for `quantity` extra meetings.
//
// The ONLY inputs are a quantity and an idempotency key (a retry with the
// same key returns the same order). There is no price, total or plan id
// to send - the backend refuses a body that carries one.
export function startCheckout({ quantity, idempotencyKey }) {
  return apiRequest('/api/plan-addons/checkout', {
    method: 'POST',
    body: { quantity, idempotency_key: idempotencyKey },
  });
}

// Reports the checkout handler's result. GRANTS NOTHING by itself: the
// backend checks the signature and asks the provider; `status` is
// 'processing' until that is confirmed, then 'paid'.
export function acknowledgeCheckout(handlerResponse) {
  return apiRequest('/api/plan-addons/checkout/acknowledge', {
    method: 'POST',
    body: {
      razorpay_order_id: handlerResponse.razorpay_order_id,
      razorpay_payment_id: handlerResponse.razorpay_payment_id,
      razorpay_signature: handlerResponse.razorpay_signature,
    },
  });
}

// { available_credits, expired_credits, pending_purchases,
// next_expires_at }. Read-only.
export function getMyCredits() {
  return apiRequest('/api/plan-addons/me');
}

// Re-checks the user's own unconfirmed purchases with the provider.
export function refreshPurchases() {
  return apiRequest('/api/plan-addons/refresh', { method: 'POST' });
}
